export function HourlyChart({ chart, forecastSource }) {
  if (!chart || chart.length === 0) return null;
  const max = Math.max(1, ...chart.flatMap(c => [c.forecast || 0, c.actual || 0]));
  const H = 140;
  const sourceLabel = forecastSource === 'pis_hourly_forecast'
    ? 'PIS forecaster'
    : forecastSource === 'last_week_actuals'
      ? 'last week actuals (stand-in)'
      : null;
  return (
    <div className="card">
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline', marginBottom: 10 }}>
        <div style={{ fontSize: 13, fontWeight: 600, color: '#212121' }}>
          Hourly forecast vs actual
        </div>
        {sourceLabel && (
          <div style={{ fontSize: 11, color: '#9e9e9e' }}>Forecast: {sourceLabel}</div>
        )}
      </div>
      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 6, height: H + 24, paddingBottom: 24, position: 'relative' }}>
        {chart.map((c, i) => {
          const fH = (c.forecast / max) * H;
          const aH = ((c.actual || 0) / max) * H;
          const isFuture = c.actual == null;
          return (
            <div key={i} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', height: H + 22, position: 'relative' }}
                 title={`Hour ${c.label} · forecast ${c.forecast} tx · actual ${c.actual ?? '—'} tx`}>
              {c.isGolden && (
                <div style={{ position: 'absolute', inset: `0 -3px 22px -3px`, background: 'rgba(249, 168, 37, 0.12)', borderRadius: 4, pointerEvents: 'none' }} />
              )}
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 2, height: H, position: 'relative', zIndex: 1 }}>
                <div title={`Forecast: ${c.forecast} tx`}
                     style={{ width: 8, height: Math.max(2, fH), background: '#bdbdbd', borderRadius: '2px 2px 0 0' }} />
                <div title={`Actual: ${c.actual ?? 0} tx`}
                     style={{ width: 8, height: Math.max(2, aH), background: '#5D4037',
                              opacity: isFuture ? 0.3 : 1,
                              border: c.isCurrent ? '1px solid #2D7A3A' : 'none',
                              borderRadius: '2px 2px 0 0' }} />
              </div>
              <div style={{ fontSize: 10, color: '#757575', marginTop: 4 }}>{c.label}</div>
            </div>
          );
        })}
      </div>
      <div style={{ fontSize: 11, color: '#757575', display: 'flex', gap: 16, marginTop: -6 }}>
        <span><span style={{ display: 'inline-block', width: 8, height: 8, background: '#bdbdbd', borderRadius: 1, marginRight: 4 }}/>Forecast</span>
        <span><span style={{ display: 'inline-block', width: 8, height: 8, background: '#5D4037', borderRadius: 1, marginRight: 4 }}/>Actual</span>
        <span><span style={{ display: 'inline-block', width: 14, height: 8, background: 'rgba(249, 168, 37, 0.25)', borderRadius: 1, marginRight: 4 }}/>Golden Hour</span>
      </div>
    </div>
  );
}
